import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../Context";
import Result from "./../CardTeaserList/CardTeaser";
import getPostalAbbreviation from "./../Global/getPostalAbbreviation";
import "./../Popup/Popup.scss";
import "./../CardTeaserList/CardTeaser.scss";
import "./BranchSchedules.scss";

function BranchSchedules() {
  const globalContext = useContext(GlobalContext);
  const [cardListState, setCardListState] = useState("close");
  const [initialTouchClientY, setInitialTouchClientY] = useState(0);
  const {
    branches,
    initialPos,
    mapsInstance,
    langcode,
    branchSchedulesVisibility,
  } = globalContext;
  const [sortedBranches, setSortedBranches] = useState(null);

  useEffect(() => {
    if (mapsInstance) {
      let sortedArray = branches.sort((a, b) => {
        let { google } = mapsInstance;
        let queryCircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          center: new google.maps.LatLng(initialPos),
          radius: 2000,
        });
        let locationA = new google.maps.LatLng({
          lat: a.fieldCoordinates.lat,
          lng: a.fieldCoordinates.lng,
        });
        let locationB = new google.maps.LatLng({
          lat: b.fieldCoordinates.lat,
          lng: b.fieldCoordinates.lng,
        });
        let markerA = new google.maps.Marker({
          position: locationA,
        });
        let markerB = new google.maps.Marker({
          position: locationB,
        });
        let distanceA = google.maps.geometry.spherical.computeDistanceBetween(
          markerA.getPosition(),
          queryCircle.getCenter()
        );
        let distanceB = google.maps.geometry.spherical.computeDistanceBetween(
          markerB.getPosition(),
          queryCircle.getCenter()
        );
        return distanceA - distanceB;
      });
      setSortedBranches(sortedArray);
    }
  }, [branches, mapsInstance, initialPos]);

  return (
    <>
      <div
        className={`card-locations-popup__opacity card-locations-branch-schedules ${
          branchSchedulesVisibility ? "card-locations-popup__opacity--show" : ""
        }`}
      ></div>
      <div
        className={`card-locations-popup card-locations-branch-schedules ${
          branchSchedulesVisibility ? "card-locations-popup--show" : ""
        }`}
      >
        <div className="branch-schedule-header">
          <h3>Horarios de atención</h3>
          <span>Horarios normales de nuestras sucursales</span>
        </div>
        {sortedBranches === null && (
          <h2 className="filter-message filter-message--loading">
            Cargando...
          </h2>
        )}

        {sortedBranches && sortedBranches.length !== 0 && (
          <div className="card-teaser-list__container">
            <div
              onTouchMove={(event) => {
                const touchEvent = event.touches[0];
                const touchY = touchEvent.clientY;

                if (touchY < initialTouchClientY) {
                  setCardListState("open");
                }
              }}
              onTouchStart={(event) => {
                const touchEvent = event.touches[0];
                const touchY = touchEvent.clientY;
                setInitialTouchClientY(touchY);
              }}
              className={`card-teaser-list__content ${
                cardListState === "open"
                  ? "card-teaser-list__content--open"
                  : ""
              }`}
            >
              <div className="card-teaser-list__cards branch-schedule-list">
                {sortedBranches.map((data, index) => {
                  return (
                    <Result
                      id={`${data.entityLabel
                        .toLowerCase()
                        .replace(/ /g, "")}-${index.toString()}`}
                      key={`result-${index}`}
                      name={data.entityLabel}
                      entityId={data.entityId}
                      type={data.fieldOfficeBranchType}
                      location={data.fieldAddress}
                      date={data.fieldSchedule}
                      dateCounter={data.fieldScheduleCounter}
                      services={data.queryFieldServices ? data.queryFieldServices : []}
                      coordinates={data.fieldCoordinates}
                      image={data.fieldOfficeBranchImage}
                      deactivateSchedule={data.fieldDesactivarHorario}
                      hasElectricCharger={data.fieldElectricCharger}
                      deactivatePhone={data.fieldDesactivarTelefono}
                      aditionalInfo={data.fieldDisclamer}
                      mobilePhone={data.fieldMobilePhone}
                      principalPhone={data.fieldPrincipalPhone}
                      geographyLocation={
                        data[
                          `fieldGeographyLocation${getPostalAbbreviation(
                            langcode
                          )}`
                        ]
                      }
                      setCardListState={setCardListState}
                      fieldLocation={data.fieldLocation}
                      isBranchSchedules={true}
                      fieldEnableBranchAppointments={data.fieldEnableBranchAppointments}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {sortedBranches && sortedBranches.length === 0 && (
          <div className="branch-schedule-error">
            <p className="place-search__submit-help-text place-search__submit-help-text--error">
              No se han podido encontrar resultados, por favor modifique su
              búsqueda o ingrese una ubicación diferente.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default BranchSchedules;
